import { CheckSettingsMaterial, MultiEditCheckSettingsElement } from './types'

/**
 * Mirrors the single-element detail pane's `elementCSisSteel`: a member counts as
 * steel only when its resolved cross section says so, everything else (including
 * an unresolved cross section) is treated as timber.
 */
export const resolveCheckSettingsMaterial = (
  crossSection: CrossSectionTimberOrCLTOrSteel | undefined,
): CheckSettingsMaterial =>
  crossSection != null && 'material' in crossSection && crossSection.material?.kind === 'Steel'
    ? 'steel'
    : 'timber'

/**
 * A section is offered only when every selected member both carries the settings
 * it edits and is of an element type the single-element detail pane shows that
 * tab for — the same gate as `Results2CheckSettingsTabs`, applied to all members.
 *
 * `memberGuids` is the full selection: members whose check settings have not
 * loaded are missing from `elements`, and editing a silent subset of what the
 * user selected would be worse than not offering the section at all.
 */
export const isCheckSettingsSectionAvailable = ({
  elements,
  memberGuids,
  hasSettings,
  isVisible,
}: {
  elements: MultiEditCheckSettingsElement[]
  memberGuids: string[]
  hasSettings: (settings: SettingsOnMember) => boolean
  isVisible: (elementType: ElementTypes, material: CheckSettingsMaterial) => boolean
}): boolean =>
  elements.length > 0 &&
  elements.length === memberGuids.length &&
  elements.every(
    ({ checkSettings, elementType, crossSection }) =>
      hasSettings(checkSettings) &&
      !!elementType &&
      isVisible(elementType, resolveCheckSettingsMaterial(crossSection)),
  )
